<template>
  <div class="min-h-screen font-inter">
    <main class="w-full">
      <LearningGoalComponent />
    </main>
  </div>
</template>
  
  <script>
  import LearningGoalComponent from '@/components/learning-goals/LearningGoalComponent.vue';

  export default {
    name: 'LearningGoalsView',
    components: {
        LearningGoalComponent,
    },
    mounted() {
      window.scrollTo(0, 0);
      this.checkForSuccessMessage();
    },
    methods: {
      checkForSuccessMessage() {
        if (this.$route.query.success === 'true' && this.$route.query.message) {
          this.$emit('show-success', this.$route.query.message);
          
          // Clean up the URL parameters
          this.$router.replace({ 
            path: this.$route.path, 
            query: {} 
          });
        }
      }
    }
  }
  </script>
  
  <style scoped>
  </style>
  